import React, { useState } from 'react';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle
} from 'reactstrap';
import SaleReportFilter from '../views/Filter/SaleReportFilter';

const CustomDateModal = (props) => {

    return (
        <Modal isOpen={props.showDateModel} centered >
            <ModalHeader style={{ backgroundColor: "white" }}>Filter</ModalHeader>
            <ModalBody style={{ backgroundColor: "white" }} >




                {props.filterFlag == "sale_report" && 
                
                <SaleReportFilter
                    allDateSelected={props.allDateSelected}
                    setAllDateSelected={props.setAllDateSelected}
                    startDate={props.startDate}
                    setStartDate={props.setStartDate}
                    endDate={props.endDate}
                    setEndDate={props.setEndDate}
                    getChallanData={props.getChallanData}
                    setShowDateModel={props.setShowDateModel}


                    // item , party , party Option , Item option
                    // ===== optical , spot challan ========
                    partyOption={props.partyOption}
                    itemOption={props.itemOption}
                    partyTable={props.partyTable}
                    itemTable={props.itemTable}
                    itemId={props.itemId}
                    partyId={props.partyId}
                    setItemId={props.setItemId}
                    setPartyId={props.setPartyId}
                    debouncedGetPartyData={props.debouncedGetPartyData}


                    // ===== posocks  challan ======
                    statusOption={props.statusOption}
                    statusTable={props.statusTable}
                    setStatusId={props.setStatusId}
                    statusId={props.statusId}


                    // vouchertype vouhcer Option 
                    voucherTypeOption={props.voucherTypeOption}
                    voucherTypeList={props.voucherTypeList}
                    setVoucherTypeName={props.setVoucherTypeName}
                    voucherTypeName={props.voucherTypeName}


                    // booking master -- boking status
                    bookingTypeOption={props.bookingTypeOption}
                    bookingTypeList={props.bookingTypeList}
                    setBookTypeFilter={props.setBookTypeFilter}
                    bookTypeFilter={props.bookTypeFilter}
                />}

            </ModalBody>
        </Modal>
    );
};

export default CustomDateModal;
